<!-- #Body -->
<div *transloco="let translated">
  <div class="modal-body">
    <div class="panel-tag ml-5 mr-5">
      Nhập số điện thoại của bạn và đảm bảo bạn có thể truy cập vào số điện thoại này, <br />
      Chúng tôi sẽ gửi cho bạn 1 mã xác thực.
    </div>

    <form class="m-5" [formGroup]="phoneForm" (keydown.enter)="onSubmit()">
      <div *ngIf="displayErrorMessage" role="alert" class="alert alert-danger ng-star-inserted">
        {{ displayErrorMessage }}
      </div>

      <div class="form-group" [formGroup]="phoneForm">
        <label class="form-label" for="input-new-phone-number">
          Số điện thoại
        </label>
        <div class="input-group d-flex flex-row">
          <div class="input-group-prepend">
            <span class="input-group-text">+84</span>
          </div>
          <input type="text" id="input-new-phone-number" class="form-control" placeholder="Ví dụ: 987654321"
            aria-label="PhoneNumber" aria-describedby="input-new-phone-number" formControlName="phoneNumber" />
          <div class="invalid-feedback" *ngIf="phoneForm.invalid && (phoneForm.dirty || phoneForm.touched)">
            Vui lòng nhập số điện thoại đúng định dạng ví dụ: 987654321
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- #Footer -->
  <div class="modal-footer justify-content-center border-top">
    <button class="mr-3 btn btn-outline-default waves-effect waves-themed" type="button" (click)="previousStep.emit()">
      <span>
        Thoát
      </span>
    </button>
    <button class="btn btn-primary px-5 waves-effect waves-themed" type="button"
      [disabled]="showWaitingWhenVerifyPhone || phoneForm.invalid" (click)="onSubmit()">
      <span *ngIf="showWaitingWhenVerifyPhone" class="spinner-border spinner-border-sm mr-1" role="status"
        aria-hidden="true"></span>
      <span>
        Gửi mã xác thực
      </span>
    </button>
  </div>
</div>
